import { DateTime } from "luxon";
import { Incentiveincomequalifiedpercentageeligibilitycriteria } from "../rebate-types";
interface IncomeEligibleTemplateData {
    percentageDetailsString: string;
    eligibilityCriteriaString: string;
}

interface PercentageTextFormatHelper {
    firstWords: string
    breakingWords: string
}

/****
 * 
 * Updated Formatting for Incentive Management Portal Rebates in Rebate finder
 * 
 * 
All incentives should have the following as the last two sentences: 

Offer valid [START DATE] through [END DATE]. Other conditions may apply; please visit the website for additional details.

The logic for when there is no Incentive End Date remains unchanged. It should read “no current end date.”



For incentives with a single incentive mechanic:
[PARTNER] offers [INCENTIVE TYPE] for [PRODUCT] via [INCENTIVE MECHANIC].

For two incentive mechanic:
[PARTNER] offers [INCENTIVE TYPE] for [PRODUCT] via [INCENTIVE MECHANIC] or [INCENTIVE MECHANIC].
Example: [Orange and Rockland Utilities] offers [rebates] for [heat pump water heaters] via [mail in process] or [online application].

For three incentive types:
[PARTNER] offers [INCENTIVE TYPE] for [PRODUCT] via [INCENTIVE MECHANIC], [INCENTIVE MECHANIC], or [INCENTIVE MECHANIC].
Example: [Orange and Rockland Utilities] offers [rebates] for [heat pump water heaters] via [mail in process], [online application], or [utility online marketplace].

For incentives on AMI, SMI, or FPL:
[PARTNER] offers [INCENTIVE TYPE] for [PRODUCT] via [INCENTIVE MECHANIC] to eligible customers. Eligibility is based on household size and income being [DETAIL] of [CRITERIA]
Example: [Orange and Rockland Utilities] offers [special pricing] for [heat pump water heaters] via [participating retailers] to eligible customers. Eligibility is based on household size and income being [less than or equal to 80%] of [area median].

For incentives on AMI, SMI, FPL, and categorical/geographic eligibility:
[PARTNER] offers [INCENTIVE TYPE] for [PRODUCT] via [INCENTIVE MECHANIC] to eligible customers. Eligibility is based on household size and income being [ELIGIBILITY DETAIL] of [ELIGIBILITY CRITERIA] or [ELIGIBILITY CRITERIA].
Example: [Orange and Rockland Utilities] offers [special pricing] for [heat pump water heaters] via [participating retailers] to eligible customers. Eligibility is based on household size and income being [less than or equal to 80%] of [area median] or [categorical eligibility].

For categorical, geographic, or both:
[PARTNER] offers [INCENTIVE TYPE] for [PRODUCT] via [INCENTIVE MECHANIC] to eligible customers. Eligibility is based on [ELIGIBILITY CRITERIA].
Example: [Orange and Rockland Utilities] offers [special pricing] for [heat pump water heaters] via [participating retailers] to eligible customers. Eligibility is based on [categorical eligibility].
Example: [Orange and Rockland Utilities] offers [special pricing] for [heat pump water heaters] via [participating retailers] to eligible customers. Eligibility is based on [location].
Example: [Orange and Rockland Utilities] offers [special pricing] for [heat pump water heaters] via [participating retailers] to eligible customers. Eligibility is based on [categorical eligibility] or [location].

 * 
 * 
 * 
 * 
 */
export const generateDescriptionWithData = (data: any, product: string, startDate: string, endDate: string, productDetail: string) => {
    const partnerName = formatPartnerName(data.workspace?.incentiveorganization?.incentiveorganizationname)
    const incentiveType = formatIncentiveType(data.incentivetype.incentivetypename)
    const displayDetail = productDetail !== "- All" && productDetail !== "- " ? " - " + productDetail : ""
    let returnedTemplate = "";
    const formattedIncomeDetailsData = isIncomeEligibleReturnsDetailsAndCriteria(data)
    const formattedCategoricalDetailsStringOrNull = gatherAndProcessCategoricalEligibilityDetailsAsString(data)
    const incomeEligibleTemplate = `${partnerName} offers ${incentiveType.toLowerCase()} for ${product.toLowerCase()} ${formatIncentiveDeliveryMechanic(data)} to eligible customers. Eligibility is based on household size and income being ${formattedIncomeDetailsData?.percentageDetailsString} percent of ${formattedIncomeDetailsData?.eligibilityCriteriaString}. Other restrictions apply; please visit the website for additional details.`
    const baseCurrentTemplate = `${partnerName} offers ${incentiveType.toLowerCase()} for ${product.toLowerCase()}  ${formatIncentiveDeliveryMechanic(data)}. Offer valid ${startDate} through ${endDate}. Other restrictions apply; please visit the website for additional details.`
    const categoricalOrGeographicEligibleTemplate = `${partnerName} offers ${incentiveType} for ${product.toLowerCase()} ${formatIncentiveDeliveryMechanic(data)} to eligible customers. Eligibility is based on ${formattedCategoricalDetailsStringOrNull}.  Other restrictions apply; please visit the website for additional details.`
    if (data?.incentiveincomequalifiedpercentageeligibilitycriterias?.size !== undefined && data?.incentiveincomequalifiedpercentageeligibilitycriterias?.size > 0) {


        if (formattedIncomeDetailsData !== null) {
            returnedTemplate = incomeEligibleTemplate
        }


    } else if (data?.incentiveincomequalifiedcategoricaleligibilitycriterias?.size !== undefined && data.incentiveincomequalifiedcategoricaleligibilitycriterias?.size > 0) {
        returnedTemplate = categoricalOrGeographicEligibleTemplate;
    } else {
        returnedTemplate = baseCurrentTemplate;
    }
    return returnedTemplate;
}

const formatIncentiveDeliveryMechanic = (data: any) => {
    let formattedDeliverMechanic = ""
    const filteredMechanics = data?.incentivedeliverymechanics as any[]
    const length = data?.incentivedeliverymechanics?.length
    if (filteredMechanics !== undefined)
        switch (length) {
            case 0:
                formattedDeliverMechanic = "via [Incentive mechanics not currently provided]"
                break;
            case 1:
                formattedDeliverMechanic = " via " + filteredMechanics[0]?.incentivedeliverymechanicsname?.toLowerCase()
                break;
            case 2:
                formattedDeliverMechanic = " via " + filteredMechanics[0]?.incentivedeliverymechanicsname?.toLowerCase() + " or " + filteredMechanics[1]?.incentivedeliverymechanicsname?.toLowerCase()
                break;
            case 3:
                formattedDeliverMechanic = " via " + filteredMechanics[0]?.incentivedeliverymechanicsname?.toLowerCase() + ", " + filteredMechanics[1]?.incentivedeliverymechanicsname?.toLowerCase() + " or " + filteredMechanics[2]?.incentivedeliverymechanicsname?.toLowerCase()
                break;
            case 4:
                formattedDeliverMechanic = " via " + filteredMechanics[0]?.incentivedeliverymechanicsname?.toLowerCase() + ", " + filteredMechanics[1]?.incentivedeliverymechanicsname?.toLowerCase() + ", " + filteredMechanics[2]?.incentivedeliverymechanicsname?.toLowerCase() + " or " + filteredMechanics[3]?.incentivedeliverymechanicsname?.toLowerCase()
                break;
            case 5:
                formattedDeliverMechanic = " via " + filteredMechanics[0]?.incentivedeliverymechanicsname?.toLowerCase() + ", " + filteredMechanics[1]?.incentivedeliverymechanicsname?.toLowerCase() + ", " + filteredMechanics[2]?.incentivedeliverymechanicsname?.toLowerCase() + ", " + filteredMechanics[3]?.incentivedeliverymechanicsname?.toLowerCase() + " or " + filteredMechanics[4]?.incentivedeliverymechanicsname?.toLowerCase()
                break;
            default:
                formattedDeliverMechanic = "via [Incentive mechanics not currently provided]"
        }
    return formattedDeliverMechanic
}

const gatherAndProcessCategoricalEligibilityDetailsAsString = (data: any) => {
    let percentageData: any;
    let categoricalCriteriaDetails = "";


    if (data.incentiveincomequalifiedcategoricaleligibilitycriterias?.size !== undefined && data.incentiveincomequalifiedcategoricaleligibilitycriterias.size > 0) {

        percentageData = data.incentiveincomequalifiedcategoricaleligibilitycriterias
        categoricalCriteriaDetails = gatherAndFormatCategoricalCriteriaTypeDetails(percentageData);

        return categoricalCriteriaDetails
    }
    else {
        return null
    }
}

const isIncomeEligibleReturnsDetailsAndCriteria = (data: any) => {
    let percentageData: Set<Incentiveincomequalifiedpercentageeligibilitycriteria>;
    let incomeCriteriaDetails = "";
    let eligibilityPercentageDetails = "";

    if (data?.incentiveincomequalifiedpercentageeligibilitycriterias?.size && data?.incentiveincomequalifiedpercentageeligibilitycriterias?.size > 0) {

        percentageData = data?.incentiveincomequalifiedpercentageeligibilitycriterias
        incomeCriteriaDetails = gatherAndFormatIncomeCriteriaTypeDetails(percentageData);
        eligibilityPercentageDetails = gatherAndFormatEligibilityPercentageDetails(percentageData)
        return {
            percentageDetailsString: eligibilityPercentageDetails,
            eligibilityCriteriaString: incomeCriteriaDetails
        } as IncomeEligibleTemplateData
    }
    else {
        return null
    }

}



    //*************** */
    //Income Qualified section
    //*************** */
    /**Gathers and formats criteria details into formatted string
     * 
     * @param data is of type IncomePercentageData[] which is simplified object interface of rowData?.incentiveincomequalifiedpercentageeligibilitycriterias (Above)
     * 
     * @returns formatted string to display critera details in generation step
     */
    const gatherAndFormatIncomeCriteriaTypeDetails = (data: any) => {
        let formattedData = "";
        Array.from(data)
        if (data.length > 1) {
            for (let dataAtindex of data) {
                if (dataAtindex !== data[data.length - 1])
                    formattedData += dataAtindex.incomequalifiedeligibilitycriteria.incomequalifiedeligibilitycriterianame.toLowerCase() + " or "
                else
                    formattedData += dataAtindex.incomequalifiedeligibilitycriteria.incomequalifiedeligibilitycriterianame.toLowerCase()
            }

        } else {
            formattedData = data[0].incomequalifiedeligibilitycriteria.incomequalifiedeligibilitycriterianame.toLowerCase()
        }

        return formattedData
    }

    const gatherAndFormatCategoricalCriteriaTypeDetails = (data: any) => {
        let formattedData = "";
        if (data.length > 1) {
            for (let dataAtindex of data) {
                if (dataAtindex !== data[data.length - 1])
                    formattedData += dataAtindex?.incomequalifiedeligibilitycriteria?.incomequalifiedeligibilitycriterianame.toLowerCase() + " or "
                else
                    formattedData += dataAtindex?.incomequalifiedeligibilitycriteria?.incomequalifiedeligibilitycriterianame.toLowerCase()
            }

        } else {
            formattedData = data[0].incomequalifiedeligibilitycriteria?.incomequalifiedeligibilitycriterianame.toLowerCase() ?? ""
        }

        return formattedData
    }
    /**Generates text to begin or break apart income qualified details in template string generation
     * 
     * @param data is singular index of IncomePercentageData 
     * @returns PercentageTextFormatHelper object to allow for easy use in formatting of strings
     */
    const getStartingAndBreakingText = (data: any) => {
        let firstWordsText = "";
        let breakingWordsText = "";
        if (data.percentageminimum !== 0 && data.percentageminimum !== 1) {
            firstWordsText = " between "
            breakingWordsText = " and "
        } else {
            firstWordsText = " less than "
        }

        return { firstWords: firstWordsText, breakingWords: breakingWordsText } as PercentageTextFormatHelper
    }

    /**Gathers and formats percentage details into a string
     * 
     * @param data is of type IncomePercentageData[] which is simplified object interface of rowData?.incentiveincomequalifiedpercentageeligibilitycriterias (Above)
     * @returns formatted string to display percentage details in generation step
     */
    const gatherAndFormatEligibilityPercentageDetails = (data: any) => {
        let formattedData = "";

        if (data.length > 1) {
            for (let dataAtindex of data) {
                let { firstWords, breakingWords } = getStartingAndBreakingText(dataAtindex)
                if (dataAtindex !== data[data.length - 1]) {
                    formattedData += firstWords + dataAtindex.percentageminimum + breakingWords + dataAtindex.percentagemaximum + " or "
                } else {
                    formattedData += firstWords + dataAtindex.percentageminimum + breakingWords + dataAtindex.percentagemaximum
                }
            }

        } else {
            let { firstWords, breakingWords } = getStartingAndBreakingText(data[0])
            if (data[0].percentageminimum !== 0) {
                formattedData = firstWords + data[0].percentageminimum + breakingWords + data[0].percentagemaximum
            } else {
                formattedData = firstWords + data[0].percentagemaximum
            }

        }

        return formattedData
    }
    export const convertDate = (date?: number) => {
        if (!date) {
            return "no date found";
        }
        return DateTime.fromMillis(date).toFormat("MM-dd-yyyy");
    };

    const formatIncentiveType = (type : string) => {
        switch(type){
            case "Rebate":
                return 'rebates'
            case "Point-of-Sale Discount":
                return 'a point-of-sale discount'
            case "Tax Credit":
                return "tax credits"
            case "Direct Install":
                return "no- or reduced-cost installation"  
            default:  
                return type

        }
    }

    const formatPartnerName = (name: string) => {
        if(name === "Federal Government"){
            return "The Federal Government"
        }
        else{
            return name
        }
    }